import React, { useContext, useEffect, useState } from 'react'

//context
import { OrgSettingsUsersContext } from '@/context/OrgSettingsUsersContext';

//interfaces
import { ITableColumn, ITableContent, ITableRows } from  '@/interfaces/simpleTable';
import { IUserWorkspaceData, WorkspaceSortByType } from  '@/interfaces/workspaces';
import { SortBy } from  '@/interfaces/toggle';

//components
import WorkspaceIconAndName from  '@/components/elements/orgSettings/tableCellItems/WorkspaceIconAndName';
import UserRolePermissions from  '@/components/elements/orgSettings/tableCellItems/buttons/userRolePermissions';



const UseUserWorkspacesTab = () => {  
    const {userId, setSortWorkspacesToggle, sortWorkspacesToggle, getUsersWorkspaces, isLoading, setIsLoading, workspacePaginationSettings, workspaceData} = useContext(OrgSettingsUsersContext);

    const addWorkspaceButton = 'Add Workspace';
    const addWorkspaceButtonLabel = 'Open Modal for adding new workspaces';
    const noDataMessage = "User has no workspaces yet";
    const columns: ITableColumn[] = [
        { title: "Workspace Name", isToggleButton: true, onSortAscendingClick: () => toggleSort(WorkspaceSortByType.WORKSPACE, SortBy.DESCENDING), onSortDescendingClick: () => toggleSort(WorkspaceSortByType.WORKSPACE, SortBy.ASCENDING) }, 
        { title: "Workspace Role", isToggleButton: true, onSortAscendingClick: () => toggleSort(WorkspaceSortByType.ROLE, SortBy.ASCENDING),  onSortDescendingClick: () => toggleSort(WorkspaceSortByType.ROLE, SortBy.DESCENDING)}
    ];
    const [tableContent, setTableContent] = useState<ITableContent>({rows: [], columns: columns});
    const [showSimpleTable, setShowSimpleTable] = useState<boolean>(false);

    useEffect(()=> {
        getUsersWorkspaces();            
    }, [sortWorkspacesToggle, userId]);

    useEffect(()=> {
        getUsersWorkspaces();            
    }, []);

    useEffect(() => { 
        if (workspaceData === undefined) {
            setShowSimpleTable(true);
            setIsLoading(true);
        }
        let rows: ITableRows[] = [];
        workspaceData?.forEach((userWorkspace: IUserWorkspaceData) => {
            const row: ITableRows = {
                content: [
                    <WorkspaceIconAndName icon={userWorkspace.icon} workspaceName={userWorkspace.name} />,
                    <UserRolePermissions id={userId} appId={userWorkspace.appId.toString()} permission={userWorkspace.permission} grantType={userWorkspace.grantType} />,
                ], 
            };
            rows.push(row);
        });
 
        setTableContent({rows: rows, columns: columns});
        setIsLoading(false);
    }, [workspaceData]);


    function toggleSort(sortByType: WorkspaceSortByType, sortBy: SortBy) {
        setSortWorkspacesToggle([sortByType, sortBy]);
    }

    function setPage(pageNumber: number) {
        getUsersWorkspaces(pageNumber);
    }

    return{addWorkspaceButton, addWorkspaceButtonLabel, noDataMessage, tableContent, isLoading, setPage, paginationSettings: workspacePaginationSettings, showSimpleTable}
}

export default UseUserWorkspacesTab